export function createProductUpsertIdentity(productId, mutationId) {
  const normalizedProductId = String(productId || "").trim();
  const normalizedMutationId = String(mutationId || "").trim();
  if (!normalizedProductId || !normalizedMutationId) {
    throw new Error("A product and mutation identifier are required.");
  }

  return {
    idempotencyKey: `product-upsert-${normalizedProductId}-${normalizedMutationId}`,
    operationId: `sync-product-${normalizedProductId}-${normalizedMutationId}`,
  };
}
